import React from 'react';

import { postWebUiApi } from '../../api';
import { WebUiAlert } from '../../components/alert';
import WebUiPageWrapper from '../../components/page-wrapper';

type BondStatus = Record<
  string,
  { status?: string; lower_interfaces?: Record<string, { state?: string }> }
>;

type Row = {
  bond: string;
  bondStatus: string;
  port: string;
  portStatus: string;
};

export default function WebUiStatusLacpPage() {
  const [rows, setRows] = React.useState<Row[]>([]);
  const [error, setError] = React.useState<string | null>(null);

  const reload = React.useCallback(async () => {
    const data = await postWebUiApi<BondStatus>({
      service: 'vlan',
      access: 'get',
      command: 'get bonds status',
    });
    const next: Row[] = [];
    Object.keys(data ?? {}).forEach((bond) => {
      const b = data[bond];
      const lowers = b?.lower_interfaces ? Object.keys(b.lower_interfaces) : [];
      if (!lowers.length) {
        next.push({
          bond,
          bondStatus: b?.status ?? '',
          port: '-',
          portStatus: '-',
        });
        return;
      }
      lowers.forEach((port, idx) => {
        next.push({
          bond: idx === 0 ? bond : '',
          bondStatus: idx === 0 ? (b?.status ?? '') : '',
          port,
          portStatus: b?.lower_interfaces?.[port]?.state ?? '',
        });
      });
    });
    setRows(next);
  }, []);

  React.useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        await reload();
        if (alive) setError(null);
      } catch (err) {
        if (alive) setError((err as Error).message);
      }
    };
    load().catch(() => {});
    const t = window.setInterval(() => load().catch(() => {}), 5000);
    return () => {
      alive = false;
      window.clearInterval(t);
    };
  }, [reload]);

  return (
    <WebUiPageWrapper titleList={['Status', 'LACP']}>
      {error ? <WebUiAlert type="error" message={error} /> : null}
      <div className="flex w-full flex-col gap-2">
        <table className="webui-table w-full">
          <thead>
            <tr className="webui-table-row-head">
              <th>Bond</th>
              <th>Bond Status</th>
              <th>Port</th>
              <th>Port Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr
                key={`${r.bond}-${r.port}-${i}`}
                className="webui-table-row-content"
              >
                <td className="truncate">{r.bond}</td>
                <td className="truncate">{r.bondStatus}</td>
                <td className="truncate">{r.port}</td>
                <td className="truncate">{r.portStatus}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </WebUiPageWrapper>
  );
}
